// extracted by mini-css-extract-plugin
export var footer = "_nj-5";
export var fulfillmentInput = "_nj-0";
export var shipDateInput = "_nj-1";
export var shipmentModal = "_nj-2";
export var shipmentModalContent = "_nj-3";
export var tableContainer = "_nj-4";